module.exports = __webpack_public_path__ + "media/assets/images/blog/QR_CODE_RICHIEDI_DEMO-99934bafcbdedb43600c6977efa9ca94.png";